import React from 'react';
import { StyledMenu } from './styles';
import { MenuItem } from '@mui/material';
import { formatValueInBrazilianCurrency } from 'utils';

function DropDown({
  open, setOpen, totalDueToday = 0, totalOverdueUnpaid = 0, totalDueFuture = 0,
}) {
  const handleClose = (e) => {
    setOpen(null);
    e.stopPropagation();
  };

  return (
    <StyledMenu
      PaperProps={{
        style: {
          maxHeight: 68 * 4.5,
        },
      }}
      id="simple-menu"
      anchorEl={open}
      keepMounted
      open={Boolean(open)}
      onClose={handleClose}
    >
      <MenuItem disableTouchRipple>
        {`Vencem hoje: ${formatValueInBrazilianCurrency(totalDueToday)}`}
      </MenuItem>
      <MenuItem disableTouchRipple>
        {`Vencidos: ${formatValueInBrazilianCurrency(totalOverdueUnpaid)}`}
      </MenuItem>
      <MenuItem disableTouchRipple>
        {`A vencer: ${formatValueInBrazilianCurrency(totalDueFuture)}`}
      </MenuItem>
    </StyledMenu>
  );
}

export default DropDown;
